export function getTalosWifiSetup(deviceCode) {
  const code = String(deviceCode || "TALOS").toUpperCase();
  const compact = code.replace(/[^A-Z0-9]/g, "").padEnd(6, "0");
  const suffix = compact.slice(-6);
  return {
    ssid: `Talos-${code}`.slice(0, 32),
    password: `Talos-${suffix}`,
    address: "http://192.168.4.1",
  };
}
